import { Loader2, Search } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router";

import { PageHeader } from "@/components/comms";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { useAdminUsers } from "@/lib/api";

import { UserTable } from "./user-table";

export function AdminUsersPage() {
  const usersQuery = useAdminUsers();
  const [search, setSearch] = useState("");

  const users = usersQuery.data ?? [];
  const filtered = users.filter((u) => {
    const q = search.toLowerCase();
    return (
      u.email.toLowerCase().includes(q) ||
      (u.first_name ?? "").toLowerCase().includes(q) ||
      (u.last_name ?? "").toLowerCase().includes(q)
    );
  });

  return (
    <div>
      <PageHeader title="User management" />
      {usersQuery.isLoading ? (
        <Card>
          <CardContent className="flex justify-center py-12">
            <Loader2 className="text-muted h-6 w-6 animate-spin" />
          </CardContent>
        </Card>
      ) : usersQuery.isError ? (
        <Card>
          <CardContent className="py-8 text-center">
            <p className="text-muted text-sm">
              Could not load users. Please{" "}
              <button type="button" onClick={() => void usersQuery.refetch()} className="underline">
                try again
              </button>{" "}
              or{" "}
              <Link to="/home" className="underline">
                go back
              </Link>
              .
            </p>
          </CardContent>
        </Card>
      ) : users.length === 0 ? (
        <p className="text-muted py-8 text-center text-sm">
          No users yet. Accounts appear here automatically the first time someone signs in with
          their Microsoft corporate account.
        </p>
      ) : (
        <>
          <div className="mb-6">
            <div className="relative">
              <Search className="text-muted absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2" />
              <Input
                placeholder="Search users..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="pl-10"
              />
            </div>
          </div>
          <UserTable users={filtered} />
        </>
      )}
    </div>
  );
}
